import React from 'react';
import './About.css';
import profilePhoto from './user-ab.jpeg'; // Replace with your profile photo
import { FaDownload } from 'react-icons/fa';

const About = () => {
  return (
    <div className="about-container" id="about">
      <h2 className="about-title">About Me</h2>
      <p className="about-text">My introduction</p>
      <div className="about-content">
        <div className="about-image">
          <img src={profilePhoto} alt="Ashish Kumar" className="about-photo" />
        </div>
        <div className="about-intro">
          <p className="about-intro-small">
            Software developer, with extensive knowledge and years of experience, working in full-stack development, microservice design, cybersecurity, blockchain technology, and cross-functional collaboration to every project.
          </p>
          <div className="about-stats">
            <div className="stat-item">
              <span className="stat-number">02+</span>
              <br />
              <span className="stat-label">years</span>
              <br />
              <span className="stat-label">experience</span>
            </div>
            <div className="stat-item">
              <span className="stat-number">20+</span>
              <br />
              <span className="stat-label">completed</span>
              <br />
              <span className="stat-label">projects</span>
            </div>
            <div className="stat-item">
              <span className="stat-number">2+</span>
              <br />
              <span className="stat-label">companies</span>
              <br />
              <span className="stat-label">worked</span>
            </div>
          </div>
          <a href="/ashish-cv.pdf" className="download-cv" download>
            Download CV <FaDownload className="icon" />
          </a>
        </div>
      </div>
    </div>
  );
}

export default About;
